import useAuthStore, { AuthStore } from "./useAuthStore";

const userSelector = (store: AuthStore) => store.user;
export default () => {
  const user = useAuthStore(userSelector);
  return user;
};
